import React, { Component } from 'react';
import Radium from 'radium';
import BubblesHeader from './BubblesHeader';
import UserServices from '../services/UserServices';

class Header extends Component {

	onGoHome() {
		window.location.href = "/";
	}

	renderProTag() {
		if (!this.props.subscribed) {
			return null;
		}

		return (
			<div style={this.props.style.global.pro}>PRO</div>
		);
	}

	renderRightSide() {
		if (!this.props.subscribed || !this.props.bubbles || !UserServices.getPreference(UserServices.BUBBLES_ON_PREFERENCE)) {
			return null;
		}

		return (
			<BubblesHeader
				bubbles={this.props.bubbles}
				style={this.props.style}
				allTasks={this.props.allTasks}
				selectedBubble={this.props.selectedBubble}
				onSelectBubble={this.props.onSelectBubble}
			/>
		)
	}

	render() {
		return (
			<div style={this.localStyles().container}>
				<div style={this.localStyles().content}>
					<div style={this.localStyles().logoHolder} onClick={() => this.onGoHome()}>
						<img alt="Logo" src={this.props.style.images.logo} style={this.localStyles().headerLogo}/>
						{this.renderProTag()}
					</div>
					{this.renderRightSide()}
				</div>
			</div>
		);
	}

	localStyles() {
		return {
			logoHolder: {
				display: "flex",
				alignItems: "center",
				flexDirection: "row"
			},
			container: {
				width: "100%",
				userSelect: "none"
			},
			content: {
				paddingLeft: 50,
				paddingRight: 50,
				paddingTop: 30,
				paddingBottom: 30,
				display: "flex",
				flexDirection: "row",
				flex: 1,
				justifyContent: "space-between",
				alignItems: "center"
			},
			headerLogo: {
				width: 95,
				height: 30,
				cursor: "pointer"
			}
		}
	}
}

export default Radium(Header);


// WEBPACK FOOTER //
// ./src/components/Header.js